import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { EAllergenActions, GetAllergen, AddAllergen, EditAllergen } from '../actions/allergen.action';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { AllergenService } from '../../Services/Allergen/allergen.service';




@Injectable()
export class AllergenEffects {

    getAllergen$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllergen>(EAllergenActions.GetAllergen),
        map(action => action.payload),
        mergeMap((payload : any) => this.allergenService.getAllergen(payload)
        .pipe(map((result: any) => ({ type: '[Allergen] Set Allergen Details', payload: result })),
          catchError((err) => of({ type: 'Set Allergen Error', payload:err, from: 'getAllergen' }))
        )
      )
    ));

    addAllergen$ = createEffect(() => this.actions$.pipe(
        ofType<AddAllergen>(EAllergenActions.AddAllergen),
        map(action => action.payload),
        mergeMap((payload : any) => this.allergenService.addAllergen(payload)
        .pipe(map((result: any) => ({ type: 'Set Allergen Success', payload: result, from: 'AddAllergen' })),
          catchError((err) => of({ type: 'Set Allergen Error', payload:err, from: 'AddAllergen' }))
        )
      )
    ));

    editAllergen$ = createEffect(() => this.actions$.pipe(
        ofType<EditAllergen>(EAllergenActions.EditAllergen),
        map(action => action.payload),
        mergeMap((payload : any) => this.allergenService.editAllergen(payload)
        .pipe(map((result: any) => ({ type: '[Allergen] Get Edit Allergen Success', payload: result, from: 'EditAllergen' })),
          catchError((err) => of({ type: '[] Get Edit Allergen Error', payload:err, from: 'EditAllergen' }))
        )
      )
    ));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private allergenService: AllergenService
    ){}
}
